var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.236,
    height: 18,
    viewBox: "0 0 21.236 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22371",
    "data-name": "Group 22371",
    transform: "translate(-2.6 -13.142)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29048",
    "data-name": "Path 29048",
    d: "M13.286,74.2c-.94.089-1.9.157-2.886.157V77.6a.754.754,0,0,0,.761.761H14.2a.754.754,0,0,0,.761-.761V74h-.022C14.449,74.067,13.912,74.134,13.286,74.2Z",
    transform: "translate(-6.055 -47.243)",
    fill: "#170A33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29049",
    "data-name": "Path 29049",
    d: "M41.532,67.151c-.47.134-.962.246-1.432.336v3.982a.754.754,0,0,0,.761.761H43.9a.769.769,0,0,0,.761-.761V66.1c-.47.2-.94.358-1.432.537C42.7,66.816,42.136,66.995,41.532,67.151Z",
    transform: "translate(-29.111 -41.11)",
    fill: "#170A33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29050",
    "data-name": "Path 29050",
    d: "M71.846,47.761a15.355,15.355,0,0,1-1.79,1.141c-.045.022-.112.067-.157.089v6.354a.754.754,0,0,0,.761.761H73.7a.754.754,0,0,0,.761-.761V45.3A14.575,14.575,0,0,1,71.846,47.761Z",
    transform: "translate(-52.244 -24.964)",
    fill: "#170A33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29051",
    "data-name": "Path 29051",
    d: "M23.316,13.737a.655.655,0,0,0-.962-.515L18.372,15.3a.656.656,0,0,0,0,1.163l1.3.694a7.5,7.5,0,0,1-2.349,2.55,14.5,14.5,0,0,1-1.365.873,14.124,14.124,0,0,1-1.432.694c-.022.022-.067.022-.089.045a16.181,16.181,0,0,1-1.566.582,2.2,2.2,0,0,1-.358.112c-.38.112-.783.246-1.208.336-.425.112-.85.2-1.275.291-.112.022-.246.045-.358.067-.447.089-.917.179-1.365.224-.47.067-.94.134-1.409.179H6.784c-.984.089-2.013.157-3.065.157a1.119,1.119,0,1,0,0,2.237h0c7.45,0,13.759-2.282,16.779-5.66l.067-.067a9.828,9.828,0,0,0,.626-.805c.022-.045.045-.067.067-.112.157-.224.268-.447.4-.671l1.208.626a.661.661,0,0,0,.962-.671Z",
    transform: "translate(0 0)",
    fill: "#170A33"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApr);
export default __webpack_public_path__ + "static/media/APR.208ff860ca6346e0a76955145d16217f.svg";
export { ForwardRef as ReactComponent };